import React from "react";
import { ArrowUp, X, Plus } from "lucide-react";

export const CasePriorities = ({ priorities, labels, onChange, busy }) => {
  const list = priorities || [];
  const others = Object.keys(labels || {}).filter((k) => !list.includes(k));
  const move = (i) => { const n = [...list]; [n[i - 1], n[i]] = [n[i], n[i - 1]]; onChange(n); };
  return (
    <div className="rounded-xl border border-[#E5E5E0] bg-white p-4" data-testid="case-priorities">
      <p className="text-sm font-semibold text-[#0B192C]">What matters most (in order)</p>
      <ol className="mt-2 flex flex-wrap gap-2">
        {list.map((k, i) => (
          <li key={k} className="inline-flex items-center gap-1 rounded-full bg-[#1E3E62] px-3 py-1.5 text-sm text-white" data-testid={`case-priority-${k}`}>
            <span className="font-semibold">{i + 1}.</span> {labels[k]}
            {i > 0 && <button type="button" disabled={busy} onClick={() => move(i)} aria-label={`Move ${labels[k]} up`} className="ml-1 p-1" data-testid={`case-priority-up-${k}`}><ArrowUp className="h-3.5 w-3.5" /></button>}
            <button type="button" disabled={busy} onClick={() => onChange(list.filter((x) => x !== k))} aria-label={`Remove ${labels[k]}`} className="p-1" data-testid={`case-priority-remove-${k}`}><X className="h-3.5 w-3.5" /></button>
          </li>
        ))}
        {!list.length && <li className="text-sm text-[#5A6B7B]">None yet — pick what matters to you.</li>}
      </ol>
      {others.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {others.map((k) => (
            <button key={k} type="button" disabled={busy} onClick={() => onChange([...list, k])}
              className="inline-flex min-h-9 items-center gap-1 rounded-full border border-[#BCCCDC] px-3 text-sm text-[#1E3E62]" data-testid={`case-priority-add-${k}`}>
              <Plus className="h-3.5 w-3.5" />{labels[k]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
